import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import Boton from '../eventos/navegacion_y_accion/Boton';
import Titulo from "../basicos/Titulo";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ImagenDefault from './../../img/imgDefault.png';
import IconosGenerales from "../iconos/IconosGenerales";
import {  fetchEditarSubcategoria, fetchObtenerSubcategoria } from '../../../peticiones_API/PeticionesSubcategoriasConvocatoria';
import ErrorForm from '../eventos/avisos/Alerta';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import { useParams } from "react-router-dom";
import { handleChangeErrors, handleSubmitErrors, todosDatosCorrectos } from '../../validacion/ValidationFormSubcategoria';
import { DatosCorrectos, ServerNoCreoCurso, ServerUrlAFExistente, DatosIncorrectos } from '../eventos/avisos/VentanaEmergente';
import { ToastContainer, toast } from "react-toastify";

const FormEditarSubcategoria = ({ categorias }) => {

    const { Id } = useParams();
    const API_URL = process.env.REACT_APP_API_URL;
    const handleChangeMultiple = (event) => {
        setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo
        
        const { options } = event.target;
        const value = [];
        for (let i = 0, l = options.length; i < l; i += 1) {
            if (options[i].selected) {

                value.push(options[i].value);
            }
        }
        setFormData(prevFormData => ({
            ...prevFormData,
            categorias: value
        }));
    };

    const [formData, setFormData] = useState({
        IdSubcategoria: '',
        nombre: '',
        url: '',
        img: null,
        categorias: [],
        categoria: false
    });

    const camposRequeridos = {
        nombre: "Debes insertar un nombre",
        img: "Debes adjuntar una imagen"
    };

    const [estadoCampoReque, setEstadoCampoReque] = useState({
        nombre: null,
        img: null
    });


    let [formCompletado, setFormCompletado] = useState(null);
    const [estadosActualizados, setEstadosActualizados] = useState(false);

    const [errorEnviarForm, setErrorEnviarForm] = useState({
        cursoDuplicado: null,

    });

    const [botonRenderClick, setBotonRenderClick] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if(event.target.name === "guardar_cambios_statico"){
            setBotonRenderClick(false);
        }else{         
            setBotonRenderClick(true);
        }

        setEstadosActualizados(false);

        handleSubmitErrors(formData, estadoCampoReque, setEstadoCampoReque, camposRequeridos, setEstadosActualizados);

    };

    useEffect(() => {
        async function fechtPrincipal() {
            try {

                const subcategoria = await fetchObtenerSubcategoria(Id);

                console.log("listado", subcategoria);

                const categoriasIds = subcategoria.Categoria ? subcategoria.Categoria.map(cat => cat.Id) : [];

                setFormData(prevFormData => ({
                    ...prevFormData,
                    IdSubcategoria: subcategoria.Id,
                    nombre: subcategoria.nombre,
                    url: subcategoria.url,
                    urlViejo: subcategoria.url,
                    img: subcategoria.img,
                    categorias: categoriasIds,
                    categoria: subcategoria.categoria,
                }));


                const campos = [
                    'nombre', 'url', 'img'
                ];

                campos.forEach(campo => {

                    if (subcategoria[campo] != null) {
                        setEstadoCampoReque(prevState => ({
                            ...prevState,
                            [campo]: false
                        }));
                    }
                });




                setFormData(prevFormData => ({ ...prevFormData, imgPortadaAnterior: subcategoria.img }));
                setPrevisualizacionImg(`${process.env.REACT_APP_API_URL}/api/cursos/subcategorias/imagen/${subcategoria.Id}/${subcategoria.img}` || null);
                


            } catch (error) {
                console.log("Ha habido un error:", error);
            }
        }

        fechtPrincipal();
    }, []);


    const asignarNombre = (file, name) => {
        let valorImg = document.getElementById("subcategoria_img").value;
        const f = new Date();
        const dia = ('0' + f.getDate()).slice(-2);
        const mes = ('0' + (f.getMonth() + 1)).slice(-2);
        const año = f.getFullYear();
        const hora = ('0' + f.getHours()).slice(-2);
        const minutos = ('0' + f.getMinutes()).slice(-2);
        const segundos = ('0' + f.getSeconds()).slice(-2);

        const normalizarTexto = (texto) => {
                return texto
                    .toLowerCase() 
                    .normalize("NFD") 
                    .replace(/[\u0300-\u036f]/g, "") 
                    .replace(/\s+/g, "-");
        };

        if (valorImg != '' && name === 'subcategoria_img') {

            //const nombreSubcategoriaNormalizado = normalizarTexto(file?.name);
            
            const nombreImg = `${dia}${mes}${año}${hora}${minutos}${segundos}_subcategoria_img`;

            setFormData(prevFormData => ({ ...prevFormData, nombreImg: nombreImg, img: nombreImg }));
        }

    }

    useEffect(() => {
        if (estadosActualizados) {
            console.log("formData", formData);
            console.log("estadoCampoReque", estadoCampoReque);

            let validacionTodosDatos = todosDatosCorrectos(formData, estadoCampoReque);
            let todosCamposFalse = validacionTodosDatos.todosCamposFalse();
            (async () => {
                if (todosCamposFalse === true) {
                    setFormCompletado(true);
                    console.log("Simulacion editar subcategoria");

                    try {

                        const response = await fetchEditarSubcategoria(formData);
                        console.log("Subcategoria creada:", response);

                    } catch (error) {

                        setFormCompletado(false);

                        if (error?.response?.data?.error === 'categoria repetida error') {
                            setErrorEnviarForm(prevFormData => ({ ...prevFormData, cursoDuplicado: true }));
                        }
                    }
                } else {
                    toast.error("Faltan campos por rellenar")
                }
            })();
        }
    }, [estadosActualizados, formData, estadoCampoReque]);



    const [previsualizacionImg, setPrevisualizacionImg] = useState(null);

    const handleChange = (event) => {
        
        setFormCompletado(null);

        const { name, value, type, files, checked } = event.target;

        let newValue;
        if (type === 'file') {
            newValue = files[0];
        } else if (type === 'checkbox') {
            newValue = checked;

            if (name == "categoria" && !checked) {
                setFormData(prevFormData => ({ ...prevFormData, categorias: [] }));
            }
        }
        else {
            newValue = value;
        }


        if (type === 'file' && files[0]) {
            const file = files[0];
            const reader = new FileReader();

            if (name === 'subcategoria_img') {
                 asignarNombre(file, name);
                reader.onloadend = () => {
                    setPrevisualizacionImg(reader.result);
                };
                reader.readAsDataURL(file);
            }
        }

        setFormData(prevFormData => ({ ...prevFormData, [name]: newValue }));
        setFormData(prevFormData => ({ ...prevFormData, url: "/subcategorias/"+formData.nombre.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "-").toLowerCase() }));
        if (name in estadoCampoReque) {
            handleChangeErrors(name, value, estadoCampoReque, setEstadoCampoReque, setEstadosActualizados);
        }

        console.log("formData", formData);
    };

    const handleDelete = () => {
        setFormCompletado(null);

        setPrevisualizacionImg(null);
        document.getElementById("subcategoria_img").value = "";
        delete formData.img;
        console.log("formData", formData);
    };


    return (
        <>
            <Form >
                <CabeceraForm>
                    <Titulo
                        texto="EDITAR UNA SUBCATEGORIA"
                        convocatoria="true"
                    />
                </CabeceraForm>

                <Container>
                    <ToastContainer/>
                    <Col>

                        <Row md="5">
                            <Col md={3}>
                            </Col>

                            <Col md={3}>
                                <Form.Group >
                                    <TituloPrincipal>Nombre <span>*</span></TituloPrincipal>
                                    <Form.Control type="name" name="nombre" value={formData.nombre || ''} onChange={handleChange} />
                                    <ErrorForm mensaje={camposRequeridos.nombre} estadoAlerta={estadoCampoReque.nombre} />
                                </Form.Group>
                            </Col>
                            <Col md={1}>
                            </Col>

                        </Row>
                        <Row className="mt-4">
                        </Row>
                        <Row md="5">
                            <Col md={3}>
                            </Col>


                            <Col md={4}>
                                <Form.Group>
                                    <InputLabel >
                                        <TituloPrincipal>Categorias </TituloPrincipal>
                                    </InputLabel>
                                    <Select
                                        disabled={!formData.categoria}
                                        multiple
                                        native
                                        value={formData.categorias}
                                        onChange={handleChangeMultiple}
                                        inputProps={{
                                            id: 'select-multiple-native',
                                        }}
                                    >
                                        {categorias.map((categoria) => (
                                            <option key={categoria.Id} value={categoria.Id}>
                                                {categoria.categoria}
                                            </option>
                                        ))}

                                    </Select>
                                </Form.Group>

                            </Col>
                            <Col md={1}>
                                <Row>
                                    <Col>
                                        <Form.Group className="d-flex align-items-center">

                                            <EstiloSwitch
                                                name="categoria"
                                                checked={formData.categoria || false}
                                                onChange={handleChange}
                                                type="switch"
                                                id="categoria"
                                            />
                                            <TituloPrincipal style={{ marginTop: "10px", marginLeft: "10px" }}>Categoria </TituloPrincipal>
                                        </Form.Group>
                                    </Col>

                                </Row>
                            </Col>


                        </Row>

                        <Row md="5">
                            <Col md={4}>
                            </Col>


                            <Col md={4}>
                                <Form.Group className="mb-3 mt-10">
                                    <TituloPrincipal>Adjuntar imagen de la subcategoria </TituloPrincipal>
                                    <Form.Control type="file" id='subcategoria_img' accept=".jpg,.jpeg,.png,.webp" max-file-size="3072"
                                        name="subcategoria_img" onChange={handleChange} />
                                    <ErrorForm mensaje={camposRequeridos.img} estadoAlerta={estadoCampoReque.img} />
                                </Form.Group>
                            </Col>
                            <Col md={1}>
                            </Col>


                        </Row>

                        <Row md="5">
                            <Col md={4}>
                            </Col>


                            <Col md={4}>
                                {previsualizacionImg ? (
                                    <div>
                                        <TituloPrincipal>Vista previa de la imagen:</TituloPrincipal>
                                        <IconosGenerales
                                        alerta="true"
                                        id="delete"
                                        onClick={handleDelete}/>
                                        
                                        <ContenedorEncabezado>
                                            <img src={previsualizacionImg} alt="Vista previa" style={{ width: '416px', height: '262px' }} />
                                        </ContenedorEncabezado>
                                    </div>
                                ) : (
                                    <div>
                                        <TituloPrincipal>Vista previa de la imagen:</TituloPrincipal>
                                        <img src={ImagenDefault} alt="Vista previa" style={{ width: '416px', height: '262px' }} />
                                    </div>
                                )}
                            </Col>
                            <Col md={1}>

                            </Col>


                        </Row>

                        <Row md="5">
                            <Col md={4}>
                            </Col>


                            <Col md={5} >
                                <ContenedorBotones style={{width:'100%'}} className="d-flex justify-content-between">
                                    <Boton
                                        convocatoria="true"
                                        grande="true"
                                        name='guardar_cambios_statico'
                                        as="button"
                                        primario="true"
                                        type="submit"
                                        onClick={handleSubmit}
                                        form="true"
                                    >
                                        Guardar
                                    </Boton>

                                    <Boton
                                        convocatoria="true"
                                        grande="true"
                                        as="button"
                                        primario="true"
                                        type="submit"
                                        onClick={handleSubmit}
                                        form="true"
                                    >
                                        Guardar y Salir
                                    </Boton>
                                    <Boton
                                        grande="true"
                                        to="/convocatoria/subcategorias"
                                    >
                                        Cancelar
                                    </Boton>
                                </ContenedorBotones>
                            </Col>
                            <Col md={1}>

                            </Col>


                        </Row>


                    </Col>

                   


                </Container>

            </Form>

            {botonRenderClick ? 
                <DatosCorrectos envioActivado={formCompletado} />         
            :             
                <DatosCorrectos envioActivado={formCompletado} redirect={false} />
            }

            <DatosIncorrectos envioActivado={formCompletado} />
            <ServerNoCreoCurso envioActivado={errorEnviarForm.cursoDuplicado} />
            <ServerUrlAFExistente envioActivado={errorEnviarForm.cursoDuplicado} />
        </>
    );
}

const CabeceraForm = styled.div`
    margin: 5% 0% 2% 35%;
`

const ContenedorBotones = styled.div`
    margin-top: 10%;
    margin-bottom: 10px;
`

const TituloPrincipal = styled(Form.Label)`
    font-weight: bold;
    font-family: 'Open Sans';
    font-size: 15.6px;
    line-height: 1.8;
    color: #4a4a4a;

    span{
        color: #ff0000;
        font-weight: 400;
    }
`

const EstiloSwitch = styled(Form.Check)`
    
    .form-check-input {
        width: 3.5em !important;
        height: 1.8em !important;
        background-size: 1.5em 1.5em;
        background-color: white;
    }

    .form-check-input:checked {
        background-color: rgb(238, 128, 93) !important;
        border: #dee2e6;
        box-shadow: 0 0 0 .25rem rgba(238, 128, 93, .25);
        --bs-form-switch-bg: url('data:image/svg+xml,%3csvg xmlns="http://www.w3.org/2000/svg" viewBox="-4 -4 8 8"%3e%3ccircle r="3" fill="rgba(0, 0, 0, 0.25)" /%3e%3c/svg%3e') !important;
    }

    .form-check-input:focus {
        border-color: #dee2e6 !important;
        box-shadow: none; 
        --bs-form-switch-bg: url('data:image/svg+xml,%3csvg xmlns="http://www.w3.org/2000/svg" viewBox="-4 -4 8 8"%3e%3ccircle r="3" fill="rgba(0, 0, 0, 0.25)" /%3e%3c/svg%3e') !important;
    }
`

const ContenedorEncabezado = styled.div`
    width: 446px !important;
    height: auto !important;
    border: 1px solid #dee2e6;
`

export default FormEditarSubcategoria;